module.exports = __webpack_public_path__ + "img/p1-c1-p4.06b23a6d.jpg";